/**
 * 密码辅助类
 */
class PasswordHelper{
  // 大小写字母、数字、特殊字符
  // 不允话数字、字母重复3个（含）以上，如 111 aaa，((?!.*(?<re1>[a-zA-Z0-9])\k<re1>{2})(?<!.*(?<re2>[a-zA-Z0-9])\k<re2>{2}))
  static regPwd = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*?()\-_])^.{8,16}$/;
  // 不允许出现的关健字，不区分大小写
  static regPwdKeyword = /(?=daan|yunkang|yunk|ykang|yk|cts|xinguan|xg|da|an)/i
  /**
   * 检查密码强度
   * 谢卫新 2022.06.02
   * @param password
   * @returns {boolean}
   */
  static isMatch(password){
    let isMatch = PasswordHelper.regPwd.test(password);
    if(isMatch){
      //如果没有出现规定的关健字，则表示匹配
      isMatch = !PasswordHelper.regPwdKeyword.test(password);
    }
    if(isMatch){
      //检查是否存在相阾重复的数据、字符，如111 aaa
      isMatch = !PasswordHelper.hasRepeatChar(password);
    }
    if (isMatch) {
      //按升序检查是否存在数字、字母连续，如 123、abc
      isMatch = !PasswordHelper.hasSeriesChar(password, true);
    }
    if (isMatch)
    {
      //按倒序检查是否存在数字、字母连续，如 321、cba
      isMatch = !PasswordHelper.hasSeriesChar(password, false);
    }
    return isMatch;
  }

  /**
   * 密码中是否存在连续数字、字母，如123 abc
   * @param password
   * @param isAsc
   * @returns {boolean}
   */
  static hasSeriesChar(password, isAsc){
    let arr = password.split('');
    let offset = isAsc ? 1 : -1;
    let times = 0;//记录有几个数字和字母出现连续
    for (let i = 1; i < arr.length; i++){
      const beforeChar = arr[i-1].charCodeAt(0);
      const currentChar = arr[i].charCodeAt(0);
      if ((beforeChar + offset) == currentChar) {
        times++;
      } else {
        times = 0;
      }
      //如果达到3个出现连续
      if (times >= 3 - 1)
      {
        return true;
      }
    }
    return false;
  }

  /**
   * 密码中是否存在连续重复的数字、字母，如111 abc
   * @param password
   * @returns {boolean}
   */
  static hasRepeatChar(password){
    let arr = password.split('');
    let times = 0;//记录有几个数字和字母出现连续
    for (let i = 1; i < arr.length; i++){
      const beforeChar = arr[i-1].charCodeAt(0);
      const currentChar = arr[i].charCodeAt(0);
      if (beforeChar == currentChar) {
        times++;
      } else {
        times = 0;
      }
      //如果达到3个出现重复
      if (times >= 3 - 1)
      {
        return true;
      }
    }
    return false;
  }
}
export default PasswordHelper;



// WEBPACK FOOTER //
// ./src/libs/PasswordHelper.js